
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ExternalLink, BookOpen, FileText, Video } from "lucide-react";
import { useCountry } from "@/contexts/country";

const ResourcesGrid = () => {
  const { countryName, countryCode } = useCountry();

  if (!countryName || !countryCode) {
    return null;
  }

  const resources = [
    {
      icon: <BookOpen className="h-6 w-6 text-nation-purple" />,
      title: "Civic Education",
      description: `Learn about ${countryName}'s democratic processes and how to engage effectively.`,
      link: "/civic-education",
      external: false
    },
    {
      icon: <FileText className="h-6 w-6 text-nation-teal" />,
      title: "Policy Documents",
      description: `Access key policy documents and legislative information for ${countryName}.`,
      link: "#",
      external: false
    },
    {
      icon: <Video className="h-6 w-6 text-nation-blue" />,
      title: "Community Forums",
      description: `Join discussions with fellow citizens about issues affecting ${countryName}.`,
      link: "#",
      external: false
    }
  ];

  return (
    <section className="py-16 px-4 bg-gray-50 dark:bg-gray-800/50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Resources for {countryName}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Access tools and information to help you stay informed and engaged in {countryName}'s democratic process.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {resources.map((resource, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow duration-300">
              <CardHeader>
                <div className="w-12 h-12 bg-gray-50 dark:bg-gray-800 rounded-lg flex items-center justify-center mb-4">
                  {resource.icon}
                </div>
                <CardTitle className="text-lg">{resource.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-6 leading-relaxed">
                  {resource.description}
                </p>
                <Button variant="outline" className="w-full" asChild>
                  {resource.external ? (
                    <a href={resource.link} target="_blank" rel="noopener noreferrer">
                      Learn More <ExternalLink className="ml-2 h-4 w-4" />
                    </a>
                  ) : (
                    <Link to={resource.link}>
                      Learn More <ExternalLink className="ml-2 h-4 w-4" />
                    </Link>
                  )}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResourcesGrid;
